import * as actions from "../action.constants";

const initialState = {
  contactModalStatus: false,
  contactModalData: {},
  contactsData: {},
};

const addContactModalStatus = (state, action) => {
  return {
    ...state,
    contactModalStatus: action.payload,
  };
};

const addContactModalData = (state, action) => {
  return {
    ...state,
    contactModalData: action.payload,
  };
};
const saveGetContactsList = (state, action) => {
  return {
    ...state,
    contactsData: action.payload || {},
  };
};

const handlers = {
  [actions.SAVE_ADD_CONTACT_MODAL_STATUS]: addContactModalStatus,
  [actions.SAVE_ADD_CONTACT_MODAL_DATA]: addContactModalData,
  [actions.SAVE_GET_CONTACTS_LIST]: saveGetContactsList,
};

export default (state = initialState, action) => {
  const handler = handlers[action.type];
  if (typeof handler === "undefined") return state;
  return handler(state, action);
};
